import React from "react";
import { navigate } from "gatsby";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";

// @material-ui/icons
import Email from "@material-ui/icons/Email";

import LockOutlined from "@material-ui/icons/LockOutlined";
// React icons
import { FaFacebook, FaGooglePlusG, FaUsers } from 'react-icons/fa';
// core components
import Header from "components/Header/Header.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import Footer from "components/Footer/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";

import firebase from "gatsby-plugin-firebase"
import "firebase/auth";
import "firebase/database"

import Alert from '@material-ui/lab/Alert';



import loginPageStyle from "assets/jss/material-kit-react/views/loginPage.jsx";
import { Grid } from '@material-ui/core';

import image from "assets/img/LoginBackground.jpg";

const customAccept = {
    background: 'linear-gradient(45deg, #50FF50 30%, #00D700 90%)',
    borderRadius: 3,
    border: 0,
    color: 'white',
    height: 48,
    padding: '0 30px',
    boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
  };

  const customDeny = {
    background: 'linear-gradient(45deg, #FF0000 30%, #FF3200 90%)',
    borderRadius: 3,
    border: 0,
    color: 'white',
    height: 48,
    padding: '0 30px',
    boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
  };



class SignupPage extends React.Component {
    constructor(props) {
        super(props);
        // we use this to make the card to appear after the page has been rendered
        this.state = {
            cardAnimaton: "cardHidden",
            showModal: false,
            birthDate: "L",
            allowSignup: false,
            nameErrorF: false,
            nameErrorL: false,
            passwordError: false,
            emailError: false,
            age: 0
        };
    }

    completeSignup = (uid, formData, points) => {

        var dateOfBirth = new Date()

        var profilePic = formData.profileURL ? formData.profileURL : "https://firebasestorage.googleapis.com/v0/b/rooftop-420.appspot.com/o/images%2FprofileHolder.png?alt=media&token=d8f8dd01-77e1-4914-a1a1-0d1a35be170a"

        firebase.database().ref('Members/' + uid).set({
            firstName: formData.firstname.value,
            lastName: formData.lastname.value,
            email: formData.email.value,
            DOB: dateOfBirth,
            profileURL: profilePic,
            verifiedEmail: false,
            Points: points,
            ID: {
                completed: false,
                front: "",
                scan: ""
            },
            New: true,
            Approved: false,
            Staff: false,
            Visits: {
                CowieRoad: 0,
                DurbanNorth: 0,
                FloridaRoad: 0,
                Overport: 0,
                Last: "No Visits"
            }
        });

        
        navigate("/MembersArea/Profile")
    }


    facebookSignup = (event) => {
        var provider = new firebase.auth.FacebookAuthProvider();
        provider.addScope('email')
        var dateOfBirth = new Date()
        
        event.preventDefault();
        firebase.auth().signInWithPopup(provider).then(function (result) {
            // This gives you a Facebook Access Token. You can use it to access the Facebook API.
           
            // The signed-in user info.
            var user = result.user;
            var uid = user.uid;
            
            var profile = result.additionalUserInfo.profile;

            
            

            firebase.database().ref('Members/' + uid).set({
                firstName: profile.first_name,
                lastName: profile.last_name,
                email: profile.email,
                DOB: dateOfBirth,
                ID: {
                    completed: false,
                    front: "",
                    scan: ""
                },
                profileURL: profile.picture.data.url,
                verifiedEmail: true,
                Points: 75,
                New: true,
                Approved: false,
            Staff: false,
            Visits: {
                CowieRoad: 0,
                DurbanNorth: 0,
                FloridaRoad: 0,
                Overport: 0,
                Last: "No Visits"
            }
            });

            navigate("/MembersArea/Profile")

            // ...
        }).catch(function (error) {
            // Handle Errors here.
            
            var errorMessage = error.message;
            // The email of the user's account used.
            
            // The firebase.auth.AuthCredential type that was used.
            
            console.log(JSON.stringify(errorMessage))
            // ...
        });
    }

    googleSignup = (event) => {
        var provider = new firebase.auth.GoogleAuthProvider();
        provider.addScope('profile');
        provider.addScope('email')
        var dateOfBirth = new Date()
        
        event.preventDefault();
        firebase.auth().signInWithPopup(provider).then(function (result) {
            // This gives you a Facebook Access Token. You can use it to access the Facebook API.
            
            // The signed-in user info.
            var user = result.user;
            var uid = user.uid;

            
            
            var profile = result.additionalUserInfo.profile;

            firebase.database().ref('Members/' + uid).set({
                firstName: profile.given_name,
                lastName: profile.family_name,
                email: profile.email,
                DOB: dateOfBirth,
                ID: {
                    completed: false,
                    front: "",
                    scan: ""
                },
                profileURL: profile.picture,
                verifiedEmail: true,
                Points: 75,
                New: true,
                Approved: false,
            Staff: false,
                Visits: {
                    CowieRoad: 0,
                    DurbanNorth: 0,
                    FloridaRoad: 0,
                    Overport: 0,
                    Last: "No Visits"
                }
            })

            
            


        }).then(() => navigate('/MembersArea/Profile')).catch(function (error) {
            // Handle Errors here.
            
            var errorMessage = error.message;
            // The email of the user's account used.
            
            // The firebase.auth.AuthCredential type that was used.
            
            console.log("Google signup ERROR: " + JSON.stringify(errorMessage))
            // ...
        });
    }

    ageCheck = (event) => {
        event.preventDefault();
        var date = event.target.verifyAge.value
        this.setState({age :new Date(date) })
        
        var age = this.calculate_age(new Date(date))
       
        if(age >= 21){
            this.setState({allowSignup: true})
            
           
        }
        else{
            console.log("under age user!")
        }
    }

    calculate_age = (dob) => { 
        var diff_ms = Date.now() - dob.getTime();
        var age_dt = new Date(diff_ms); 
        console.log(age_dt.getUTCFullYear() - 1970)
      
        return Math.abs(age_dt.getUTCFullYear() - 1970);
    }



    handelSignup = (event) => {
        event.preventDefault();
        var formData = event.target;

        var firstN = formData.firstname.value
        

        if (formData.firstPass.value !== formData.confPass.value) {
            console.log("Passwords dont match");
            this.setState({passwordError: true})
            return;
        }
        if(firstN.includes('-')){
            this.setState({nameErrorF: true})
            console.log('user name contains -')
            return;
        }
        if(formData.firstname.value == null || formData.lastname.value == null)
        {
            return;
        }
             
            firebase.auth().createUserWithEmailAndPassword(formData.email.value, formData.firstPass.value,).then(result => {
                var uid = result.user.uid
                var user = firebase.auth().currentUser;
                user.updateProfile({
                    displayName: `${formData.firstname.value} ${formData.lastname.value}`,
                })
    
    
                firebase.database().ref('Members/' + uid).set({
                    firstName: formData.firstname.value,
                    lastName: formData.lastname.value,
                    email: formData.email.value,
                    DOB: new Date(),
                    profileURL: "",
                    verifiedEmail: false,
                    Points: 25,
                    ID: {
                        completed: false,
                        front: "",
                        scan: ""
                    },
                    New: true,
                    Approved: false,
            Staff: false,
            Visits: {
                CowieRoad: 0,
                DurbanNorth: 0,
                FloridaRoad: 0,
                Overport: 0,
                Last: "No Visits"
            }
                }).then(() => navigate("/MembersArea/Profile"))
    
            }).catch((error) => {
                
                var errorMessage = error.message;
                console.log("error creating user")
                console.log(JSON.stringify(errorMessage))
            });
            
       
    }

    acceptAge = (e) => {
        e.preventDefault()
        this.setState({allowSignup: true})
    }

    decline = (e) => {
        e.preventDefault()
        navigate("/")
    }


    componentDidMount() {
        // we add a hidden class to the card and after 700 ms we delete it and the transition appears
        setTimeout(
            function () {
                this.setState({ cardAnimaton: "" });
            }.bind(this),
            800
        );
    }
    render = () => {
        const { classes, ...rest } = this.props;

        return (
            <div>
                <Header
                    absolute
                    color="transparent"
                    brand="Material Kit React"
                    rightLinks={<HeaderLinks />}
                    {...rest}
                />
                <div
                    className={classes.pageHeader}
                    style={{
                        backgroundImage: "url(" + image + ")",
                        backgroundSize: "cover",
                        backgroundPosition: "top center"
                    }}
                >

                    <div className={classes.container}>
                        <GridContainer justify="center">
                            <GridItem xs={12} sm={12} md={8}>
                                {this.state.allowSignup ? 
                                <Card className={classes[this.state.cardAnimaton]}>
                                    <form className={classes.form} id="signupForm" onSubmit={e => this.handelSignup(e)}>
                                        <CardHeader color="primary" className={classes.cardHeader}>
                                            <h4>Signup</h4>
                                            <div className={classes.socialLine}>
                                                <Button
                                                    justIcon
                                                    
                                                    target="_blank"
                                                    color="transparent"
                                                    onClick={e => this.facebookSignup(e)}
                                                >
                                                    <FaFacebook />
                                                </Button>
                                                <Button
                                                    justIcon
                                                    
                                                    target="_blank"
                                                    color="transparent"
                                                    onClick={e => this.googleSignup(e)}
                                                >
                                                    <FaGooglePlusG />
                                                </Button>
                                            </div>
                                        </CardHeader>
                                        <p className={classes.divider}>Or Be Classical</p>
                                        <CardBody>
                                            <Grid container spacing={1}>
                                                <GridItem xs={12} sm={12} md={5}>
                                                    <CustomInput
                                                        labelText="Firstname"
                                                        id="firstname"
                                                        
                                                        formControlProps={{
                                                            fullWidth: true,
                                                            placeholder: "Firstname",
                                                        }}
                                                        inputProps={{
                                                            placeholder: "Firstname",
                                                            autocomplete: 'given-name',
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    <FaUsers />
                                                                </InputAdornment>
                                                            )
                                                        }}
                                                    />
                                                    {this.state.nameErrorF ? <Alert severity="error">Firstname contains invalid characters!</Alert> : ""}
                                                </GridItem>
                                                <GridItem xs={12} sm={12} md={2}>

                                                </GridItem>
                                                <GridItem xs={12} sm={12} md={5}>
                                                    <CustomInput
                                                        labelText="Lastname"
                                                        id="lastname"
                                                        formControlProps={{
                                                            fullWidth: true
                                                        }}
                                                        inputProps={{
                                                            
                                                            autocomplete: 'family-name',
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    <FaUsers />
                                                                </InputAdornment>
                                                            )
                                                        }}
                                                    />
                                                    {this.state.nameErrorL ? <Alert severity="error">Lastname contains invalid characters!</Alert> : ""}
                                                </GridItem>
                                                
                                                <GridItem xs={12} sm={12} md={12}>
                                                    <CustomInput
                                                        labelText="Email..."
                                                        id="email"
                                                        formControlProps={{
                                                            fullWidth: true
                                                        }}
                                                        inputProps={{
                                                            autocomplete: 'email',
                                                            type: "email",
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    <Email className={classes.inputIconsColor} />
                                                                </InputAdornment>
                                                            )
                                                        }}
                                                    />
                                                    {this.state.emailError ? <Alert severity="error">Invalid email!</Alert> : ""}
                                                </GridItem>
                                                <GridItem xs={12} sm={12} md={5}>
                                                    <CustomInput
                                                        labelText="Password"
                                                        id="firstPass"
                                                        formControlProps={{
                                                            fullWidth: true
                                                        }}
                                                        inputProps={{
                                                            autocomplete: 'new-password',
                                                            type: "password",
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    <LockOutlined />
                                                                </InputAdornment>
                                                            )
                                                        }}
                                                    />
                                                    
                                                </GridItem>
                                                <GridItem xs={12} sm={12} md={2}>

                                                </GridItem>
                                                <GridItem xs={12} sm={12} md={5}>
                                                    <CustomInput
                                                        labelText="Confirm Password"
                                                        id="confPass"
                                                        formControlProps={{
                                                            fullWidth: true
                                                        }}
                                                        inputProps={{
                                                            autocomplete: 'new-password',
                                                            type: "password",
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    <LockOutlined />
                                                                </InputAdornment>
                                                            )
                                                        }}
                                                    />
                                                </GridItem>
                                                <GridItem xs={12} sm={12} md={12}>
                                                {this.state.passwordError ? <Alert severity="error">Passwords do not match!</Alert> : ""}
                                                </GridItem>
                                                
                                            </Grid>







                                        </CardBody>
                                        <CardFooter className={classes.cardFooter}>
                                            <Button simple color="primary" size="lg" type="submit">
                                                Register
                      </Button>
                                        </CardFooter>
                                    </form>
                                </Card>
   : <Card className={classes[this.state.cardAnimaton]}>
       <CardHeader color="primary" className={classes.cardHeader}>
           <h4>Please confirm that you are over the age of 21!</h4>
       </CardHeader>
       <p className={classes.divider}>You need to be 21 or over in order to become a member!</p>
       <CardBody>
           

       </CardBody>
       <CardFooter className={classes.cardFooter} >
           <Grid container justify="space-between">
               <Grid item >
       <Button color="primary" size="md" variant="contained" style={customDeny} onClick={(e) => this.decline(e)}>
          I am under 21
      </Button>
      </Grid>
      <Grid item>
       <Button color="primary" size="md" variant="contained" style={customAccept} onClick={(e) => this.acceptAge(e)}>
          I am over 21
      </Button>
      </Grid>
      </Grid>
       </CardFooter>
</Card> }
                                <br />
                    <br />
                            </GridItem>
                        </GridContainer>
                    </div>
                    <br />
                    <br />
                    <br />
                    <br />
                    <Footer whiteFont />
                </div>
            </div >
        );
    }
}

export default withStyles(loginPageStyle)(SignupPage);
